<template>
  <div class="page landing" :class="{vivo,hnxtm}">
    <section class="content">
      <div class="button" @click="handleDownload">去天美贷认证</div>
      <DownloadQuestion :config="{type:'APP'}"/>
    </section>
    <download-cover v-if="isShowMask" />
    <ios-download v-model="downloadVisible"></ios-download>
    <ios-wxmp-dialog v-model="iosWxmpQRCodeDialogVisible"></ios-wxmp-dialog>
    <ios-wxmp-link-dialog v-model="iosWxmpLinkDialogVisible"></ios-wxmp-link-dialog>
    <web-clip-pop v-model="webclipPopVisible" @onClose="webclipPopVisible=false"/>
    <web-clip-copy-pop v-model="copyPopVisible" @onClose="copyPopVisible=false"/>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant'
import { judgeClientSystem, isWxMiniprogram, isBaiduMiniprogram, isIOS } from '@/assets/utils'
import DownloadCover from '@/components/download-cover'
import IosDownload from '@/components/ios-download-static'
import IosWxmpDialog from '@/components/ios-wxmp-qrcode-dialog'
import IosWxmpLinkDialog from '@/components/ios-wxmp-link-dialog'
import isIntercept from '@/assets/intercept-mixin'
import WebClipPop from '../components/web-clip-pop.vue'
import WebClipCopyPop from '../components/web-clip-copy-pop.vue'
import DownloadQuestion from '../components/downloadQuestion.vue'
export default {
  name: 'landingGeneralResult',
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    DownloadCover,
    IosDownload,
    WebClipPop,
    WebClipCopyPop,
    IosWxmpDialog,
    IosWxmpLinkDialog,
    DownloadQuestion
  },
  data () {
    return {
      home: this.$route.query.home, // 是否直接跳转首页，值为T
      auto: this.$route.query.auto, // 是否自动下载，值为T
      vivo: ['H5-wl'].includes(this.$route.query.channel),
      isIos: judgeClientSystem() === 'IOS',
      downloadVisible: false,
      hnxtm: false,
      channel: '',
      webclipPopVisible: false,
      copyPopVisible: false,
      iosWxmpQRCodeDialogVisible: false,
      iosWxmpLinkDialogVisible: false
    }
  },
  async created () {
    this.$bus.$emit('ready')
    this.hnxtm = localStorage.getItem('hnxtm')
    this.channel = this.$route.query.channel || this.$storage.get('channel') || 'official'
    await isIntercept(this.channel)
    if (window && window.my && window.my.getEnv) {
      window.my.getEnv(function (res) {
        if (res.miniprogram) { // 当前是小程序环境，postMessage到webview执行跳转
          window.my.postMessage({
            actionType: 3,
            url: location.href
          })
        }
      })
    }
    if (this.auto === 'T' && !this.isShowMask) {
      this.handleDownload()
    }
  },
  computed: {
    downloadButtonTitle () {
      if (isWxMiniprogram() || isBaiduMiniprogram()) {
        return '点击复制链接到浏览器打开'
      }
      return this.iosDownload ? `下载${this.packageKey}立即提现` : '下载天美贷立即提现'
    }
  },
  methods: {
    // 下载事件
    async handleDownload () {
      if (isIOS()) {
        this.downloadVisible = true
      } else {
        const url = await this.getAndradoidUrl()
        if (url) {
          window.location = url
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

@keyframes rotate {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
.landing {
  height: 1689px;
  background-image:url(https://static.ndmicro.com/tmd/landing/refund-auth/img_1@2x.png);
  background-position: top center;
  background-repeat: no-repeat;
  background-color: #444D87;
  background-size: 100% 100% !important;
  padding-top: 1px;

  .content{
    .button{
      width: 630px;
      height: 100px;
      line-height: 100px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      text-align: center;
      font-size: 36px;
      color: #FFFFFF;
      border-radius: 60px;
      box-shadow: 0px 7px 20px 0px rgba(226, 48, 48, 0.15);
      margin: 858px auto 0;
      font-weight: bold;
      animation: rotate 1s linear infinite;
    }
    
  }
}
</style>